import {
  USER_LOGIN,
  USER_LOGOUT,
  CLEAR_USER_LOGGED,

  GET_USERINFO,
  UPDATE_USERINFO,

  GET_VIP_INFORMATION,

  GET_RECENT_HOT_EVENT,

  UPDATE_USER_AVATAR,
  UNBIND_WECHAT,
  UPDATE_WECHAT_DATA,

  GET_MY_INVOICE,
  SUBMIT_AN_INVOICE,

  GET_INDEX_CASE_REVIEWS,
  GET_INDEX_CASE_NEWS,
  GET_INDEX_REPORT_NEWS,
  GET_INDEX_COMPARE,

  GET_RANK_INFO,
  GET_RANK_EVENTS,
  GET_RANK_BRANDS,

  UPDATE_COMPARE_IDS,

  EVENT_GAUGE_DATA,
  EVENT_LIQUID_FILL_DATA,

  GLOBAL_SEARCH

} from './mutiation'

import client from '../server/server'

/**
 * 用户登录
 */
export const UserLogin = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    client.login(data)
      .then(res => {
        if (res.success) {
          // let user = {
          //   username: res.data.userName,
          //   uid: res.data.userId,
          //   roleId: res.data.roleId,
          //   token: res.data.token
          // }
          commit(USER_LOGIN, {
            user: res.data
          })
          commit(UPDATE_USER_AVATAR, {
            url: res.data.headUrl
          })
          resolve(res.data)
        } else {
          reject(res.message)
        }
      })
  })
}
/**
 * 用户微信登录
 */
export const UserWechatLoginPoll = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    client.checkWechatLoginPoll(data)
      .then(res => {
        if (res.success) {
          if (res.data.check === 1) {
            // let user = {
            //   username: res.data.data.userName,
            //   uid: res.data.data.userId,
            //   roleId: res.data.data.roleId,
            //   token: res.data.data.token
            // }
            commit(USER_LOGIN, {
              user: res.data.data
            })
            commit(UPDATE_USER_AVATAR, {
              url: res.data.data.headUrl
            })
          }
          resolve(res)
        } else {
          reject(res.message)
        }
      })
  })
}

export const UpdateWechat = ({ commit }, data) => {
  commit(UPDATE_WECHAT_DATA, data)
}

export const PollWechatUserBind = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    client.pollWechatUserBind(data)
      .then(res => {
        if (res.success) {
          resolve(res)
        } else {
          reject(res.message)
        }
      })
  })
}

/**
 * 微信解绑
 */
export const UnbindWechatUserCenter = ({ commit }) => {
  return new Promise((resolve, reject) => {
    client.unbindWechatUserCenter()
      .then(res => {
        commit(UNBIND_WECHAT)
      })
  })
}

/**
 * 微信用户绑定
 */
export const WechatUserBind = ({ commit }) => {
  return new Promise((resolve, reject) => {
    client.bindWechatUserCenter()
      .then(res => {
        //
      })
  })
}

// 退出
export const UserLogout = ({ commit }) => {
  return new Promise((resolve, reject) => {
    client.logout()
    commit(USER_LOGOUT, {})
    resolve({})
  })
}

export const clearUserLogged = ({ commit }) => {
  commit(CLEAR_USER_LOGGED)
}

/**
 * 全局事件搜索
 */
export const GlobalSearch = ({commit}, data) => {
  return new Promise((resolve, reject) => {
    client.getSearchEvents(data)
      .then(res => {
        if (res.success) {
          resolve(res.data)
          commit(GLOBAL_SEARCH, {
            params: data,
            list: res.data.list
            // pages: {
            //   sum: res.data.pages,
            //   now: res.data.pageNum,
            //   total: res.data.total
            // }
          })
        } else {
          reject(new Error())
        }
      })
  })
}

/**
 * 收藏后合并事件搜索结果
 */
export const CollectSearch = ({commit}, data) => {
  commit(GLOBAL_SEARCH, {
    params: data.params,
    list: data.list,
    pages: data.pages
  })
}

// GET_USERINFO,
// UPDATE_USERINFO

export const GetUserinfo = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    client.getUserinfoUserCenter()
      .then(res => {
        resolve(res)
        commit(GET_USERINFO, {
          userinfo: res.data
        })
      })
  })
}

// export const UpdateUserinfo = ({commit}, data) => {
//   return new Promise((resolve, reject) => {
//     client.updateUserinfoUserCenter(data)
//       .then(res => {
//         if (res.success) {
//           resolve(res.data)
//           commit(UPDATE_USERINFO, {
//             userinfo: data
//           })
//         } else {
//           reject(new Error())
//         }
//       })
//   })
// }

export const updateUserinfo = ({commit}, data) => {
  // console.log(data)
  commit(UPDATE_USERINFO, data)
}

export const GetMyVipInformation = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    // GET_VIP_INFORMATION
    client.getMyVipInformamtion(params)
      .then(res => {
        // if (res.success) {
        resolve(res.data)
        commit(GET_VIP_INFORMATION, {
          vipinfo: res
        })
        // } else {
        //   reject(new Error())
        // }
      })
  })
}

export const GetRecentHotEvent = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    client.getIndexRecentHotList(params)
      .then(res => {
        if (res.success) {
          resolve(res)
          commit(GET_RECENT_HOT_EVENT, {
            list: res.data,
            params: params
          })
        } else {
          reject(new Error())
        }
      })
  })
}

// 更新用户头像
export const UpdateUserAvatar = ({commit}, data) => {
  return new Promise((resolve, reject) => {
    client.updateUserAvatar(data)
      .then(res => {
        if (res.success) {
          resolve(res.data)
          commit(UPDATE_USER_AVATAR, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

// 获取用户发票列表
export const GetMyInvoice = ({commit}, data) => {
  return new Promise((resolve, reject) => {
    client.getInvoiceList(data)
      .then(res => {
        if (res.success) {
          resolve(res.data)
          commit(GET_MY_INVOICE, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

// 提交我的发票开具
export const SubmitMyInvoice = ({commit}, data) => {
  return new Promise((resolve, reject) => {
    client.submitAnInvoice(data)
      .then(res => {
        if (res.success) {
          resolve(res.data)
          commit(SUBMIT_AN_INVOICE, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * ------------------------------------------------------------------------------------REBUILD
 */
/**
 * @description 获取首页案例动态
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getIndexCaseNews = ({commit}) => {
  return new Promise((resolve, reject) => {
    client.getIndexCaseNews()
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_INDEX_CASE_NEWS, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 获取首页案例复盘
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getIndexCaseReviews = ({commit}) => {
  return new Promise((resolve, reject) => {
    client.getIndexCaseReviews()
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_INDEX_CASE_REVIEWS, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 获取首页报告动态
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getIndexReportNews = ({commit}) => {
  return new Promise((resolve, reject) => {
    client.getIndexReportNews()
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_INDEX_REPORT_NEWS, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 获取首页对比
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getIndexCompare = ({commit}) => {
  return new Promise((resolve, reject) => {
    client.getIndexCompare()
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_INDEX_COMPARE, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 获取榜单配置
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getRankInfo = ({commit}) => {
  return new Promise((resolve, reject) => {
    client.getRankInfo()
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_RANK_INFO, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 获取事件榜
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getRankEvents = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    client.getRankEvents(params)
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_RANK_EVENTS, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 获取品牌榜
 * @param commit
 * @returns {Promise<unknown>}
 */
export const getRankBrands = ({commit}, params) => {
  return new Promise((resolve, reject) => {
    client.getRankBrands(params)
      .then(res => {
        if (res.code === 200) {
          resolve(res.data)
          commit(GET_RANK_BRANDS, res.data)
        } else {
          reject(new Error(res.message))
        }
      })
  })
}

/**
 * @description 更新对比事件
 * @param commit
 * @param data
 */
export const updateCompareIds = ({commit}, data) => {
  commit(UPDATE_COMPARE_IDS, data)
}

/**
 * @description 事态严重性数据
 * @param commit
 * @param data
 */
export const eventGaugeData = ({commit}, data) => {
  commit(EVENT_GAUGE_DATA, data)
}

/**
 * @description 公关传播效果评价数据
 * @param commit
 * @param data
 */
export const eventLiquidFillData = ({commit}, data) => {
  commit(EVENT_LIQUID_FILL_DATA, data)
}



// WEBPACK FOOTER //
// ./src/pages/index/store/action.js